import { Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'


export const FormStepValidyStatus = ({useFetchInit}) => {
  
    const {
        //------------- Generales
        defaultData,
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const {stepApplilication} = globalStates
    const {handleClickReturnStep, handleClickHideForm} = Actions

    const { FormRequestGlobal :{onInputChange, formState, onSelectSearchChange} } = Forms
    

    return (
        <>
            <Typography variant="caption"> 
                * Disponible cuando la solicitud haya sido respondida (NO EDITABLE):
            </Typography>
            <div className="border-bottom border-dark"></div>
            <div className="pt-4"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="vigencia_check">* Estado Vigencia</label>
                        <CustomAutocomplete
                            customId="vigencia_check"
                            customName="vigencia_check"
                            customValue={formState.vigencia_check}
                            customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'aprobacion_check', value: value.value }})}
                            customPlaceholder='Seleccionar un modo'
                            customOptions={
                                defaultData.optionsAprobacionCheck.map(({ value, label }) => ({
                                    value: value,
                                    name: label
                                }))
                            }
                            customDisabled={true}
                            customDisableClearable={true}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <FormControl fullWidth>
                        <label htmlFor="vigencia_fecha">* Fecha marcaje</label>
                        <TextField
                            id='vigencia_fecha'
                            name='vigencia_fecha'
                            value={ formState.vigencia_fecha }
                            onChange={ onInputChange }
                            placeholder='Fecha de marcaje'
                            size='small'
                            type='date'
                            hiddenLabel
                            variant="filled"
                            required
                            InputProps={{
                                readOnly: true
                            }}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className="text-center">
                    {stepApplilication !== 0 && (
                        <Button 
                            startIcon={<ArrowLeftCircle/>}
                            variant="contained"
                            type="button" 
                            className='btn-round'
                            color='warning'
                            onClick={handleClickReturnStep} 
                            sx={{ marginTop:2, marginRight: 1, marginLeft:    1 }}
                        >
                            Volver
                        </Button>
                    )}

                        <Button
                            endIcon={<ArrowRightCircle/>}
                            variant="contained"
                            type="button"
                            className='btn-round'
                            color='primary'
                            sx={{marginTop:2,  marginRight: 1, marginLeft: 1 }}
                            onClick={handleClickHideForm}
                        >       
                            {stepApplilication === 5 ? 'Finalizar' : 'Continuar'}
                        </Button>
                </div>
        </>
    )
    
}
